import { useUrlLogoutPath } from "./useUrlLogoutPath";

export const useUrlLogout = () => {
  const urlLogoutPath = useUrlLogoutPath();
  return () => {
    window.location.replace(urlLogoutPath);
  };
};
